import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { ListItem, GroupedListItem } from '../../../types/listItem';
import { SharedModuleV4 } from '../../../shared/sharedv4.module';
import { MatInputModule } from '@angular/material/input';
import { FormFieldAutocompleteComponent } from '../form-field-autocomplete/form-field-autocomplete.component';
import { ErrorStateMatcher } from '@angular/material/core';
import { MyErrorStateMatcher } from '../../../types/v4/custom-error-state-matcher';
import { SelectListType } from '../form-field-select/form-field-select.component';
import { RoleEnum as RoleEnumV4 } from '../../../api/v4/models/Models/v4/Application/EmploymentDetails/role-enum';
import { IndustryClassificationEnum as IndustryClassificationEnumV4 } from '../../../api/v4/models/Models/v4/Application/EmploymentDetails/industry-classification-enum';

@Component({
    selector: 'app-form-field-select-grouped',
    standalone: true,
    imports: [CommonModule, MatFormFieldModule, MatSelectModule,
        CommonModule,
        SharedModuleV4,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        FormFieldAutocompleteComponent
    ],
    templateUrl: './form-field-select-grouped.component.html',
    styleUrl: './form-field-select-grouped.component.scss',
    providers: [
        { provide: ErrorStateMatcher, useClass: MyErrorStateMatcher }
    ]
})

export class FormFieldSelectGroupedComponent {
    @Input() control!: FormControl;
    @Input() label: string = '';
    @Input() hint: string = '';
    @Input() groupedOptions: GroupedListItem[] = [];
    @Input() listType: SelectListType = SelectListType.Custom;


    ngOnInit(): void {
        if (this.listType == SelectListType.OccupationTypesV4) {
            const profKnowledgeWorkers: ListItem[] = [
                { value: RoleEnumV4.EducationProfessionals, displayName: 'Education Professionals', valueCaption: RoleEnumV4.EducationProfessionals },
                { value: RoleEnumV4.HealthProfessionals, displayName: 'Health Professionals and Support Workers', valueCaption: RoleEnumV4.HealthProfessionals },
                { value: RoleEnumV4.LegalSocialandWelfareProfessionals, displayName: 'Legal, Social and Welfare Professionals', valueCaption: RoleEnumV4.LegalSocialandWelfareProfessionals },
                { value: RoleEnumV4.BusinessFinanceandMarketingProfessionals, displayName: 'Business, Human Resource and Marketing Professionals', valueCaption: RoleEnumV4.BusinessFinanceandMarketingProfessionals },
                { value: RoleEnumV4.ArtsandMediaAndSportsProfessionals, displayName: 'Arts, Media, and Sports Professionals', valueCaption: RoleEnumV4.ArtsandMediaAndSportsProfessionals },
                { value: RoleEnumV4.EngineeringIctAndTechnicalProfessionals, displayName: 'Engineering, ICT, and Technical Professionals', valueCaption: RoleEnumV4.EngineeringIctAndTechnicalProfessionals },
                { value: RoleEnumV4.ScienceAndResearchProfessionals, displayName: 'Science and Research Professionals', valueCaption: RoleEnumV4.ScienceAndResearchProfessionals },
                { value: RoleEnumV4.PublicSectorGovernmentRoles, displayName: 'Public Sector/Government Roles', valueCaption: RoleEnumV4.PublicSectorGovernmentRoles },
            ];

            const tradesAndTechnical: ListItem[] = [
                { value: RoleEnumV4.AutomotiveAndElectrotechnologyTradesWorkers, displayName: 'Automotive and Electrotechnology Trades Workers', valueCaption: RoleEnumV4.AutomotiveAndElectrotechnologyTradesWorkers },
                { value: RoleEnumV4.ConstructionAndMiningWorkers, displayName: 'Construction and Mining Workers', valueCaption: RoleEnumV4.ConstructionAndMiningWorkers },
                { value: RoleEnumV4.AgricultureHorticultureAndAnimalWorkers, displayName: 'Agriculture, Horticulture, and Animal Workers', valueCaption: RoleEnumV4.AgricultureHorticultureAndAnimalWorkers },
                { value: RoleEnumV4.CleaningAndMaintenanceWorkers, displayName: 'Cleaning and Maintenance Workers', valueCaption: RoleEnumV4.CleaningAndMaintenanceWorkers },
            ];

            const businessCustomerFacing: ListItem[] = [
                { value: RoleEnumV4.ClericalAndAdministrativeWorkers, displayName: 'Clerical and Administrative Workers', valueCaption: RoleEnumV4.ClericalAndAdministrativeWorkers },
                { value: RoleEnumV4.RetailAndSalesWorkers, displayName: 'Retail and Sales Workers', valueCaption: RoleEnumV4.RetailAndSalesWorkers },
                { value: RoleEnumV4.HospitalityAndFoodServicesWorkers, displayName: 'Hospitality and Food Services Workers', valueCaption: RoleEnumV4.HospitalityAndFoodServicesWorkers },
                { value: RoleEnumV4.RealEstateAndPropertyServices, displayName: 'Real Estate and Property Services', valueCaption: RoleEnumV4.RealEstateAndPropertyServices },
            ];

            const operationalAndTransport: ListItem[] = [
                { value: RoleEnumV4.TransportAndLogisticsWorkers, displayName: 'Transport and Logistics Workers', valueCaption: RoleEnumV4.TransportAndLogisticsWorkers },
                { value: RoleEnumV4.ManufacturingAndProductionWorkers, displayName: 'Manufacturing and Production Workers', valueCaption: RoleEnumV4.ManufacturingAndProductionWorkers },
                { value: RoleEnumV4.SecurityAndProtectiveServices, displayName: 'Security and Protective Services', valueCaption: RoleEnumV4.SecurityAndProtectiveServices },
                { value: RoleEnumV4.EmergencyServices, displayName: 'Emergency Services', valueCaption: RoleEnumV4.EmergencyServices },
            ];

            const leadershipAndManagement: ListItem[] = [
                { value: RoleEnumV4.ManagersAndExecutives, displayName: 'Managers and executives', valueCaption: RoleEnumV4.ManagersAndExecutives },
            ];

            const groupedOptions: GroupedListItem[] = [
                {
                    label: 'Profession / Knowledge Workers',
                    options: profKnowledgeWorkers
                },
                {
                    label: 'Trades & Technical',
                    options: tradesAndTechnical
                },
                {
                    label: 'Business Support / Customer-facing',
                    options: businessCustomerFacing
                },
                {
                    label: 'Operational & Transport',
                    options: operationalAndTransport
                },
                {
                    label: 'Leadership & Management',
                    options: leadershipAndManagement
                }
            ];

            this.groupedOptions = groupedOptions;
        }
        else if (this.listType == SelectListType.IndustryClassificationsV4) {

            const tradesAndPrimaryIndustries: ListItem[] = [
                { value: IndustryClassificationEnumV4.AgricultureForestryAndFishing, displayName: 'Agriculture, Forestry and Fishing', valueCaption: IndustryClassificationEnumV4.AgricultureForestryAndFishing },
                { value: IndustryClassificationEnumV4.Construction, displayName: 'Construction', valueCaption: IndustryClassificationEnumV4.Construction },
                { value: IndustryClassificationEnumV4.Mining, displayName: 'Mining', valueCaption: IndustryClassificationEnumV4.Mining },
            ];
            const consumerServicesAndRetail: ListItem[] = [
                { value: IndustryClassificationEnumV4.AccommodationAndFoodServices, displayName: 'Accommodation and Food Services', valueCaption: IndustryClassificationEnumV4.AccommodationAndFoodServices },
                { value: IndustryClassificationEnumV4.ArtsAndRecreationServices, displayName: 'Arts and Recreation Services', valueCaption: IndustryClassificationEnumV4.ArtsAndRecreationServices },
                { value: IndustryClassificationEnumV4.RentalHiringAndRealEstateServices, displayName: 'Rental, Hiring and Real Estate Services', valueCaption: IndustryClassificationEnumV4.RentalHiringAndRealEstateServices },
                { value: IndustryClassificationEnumV4.RetailTrade, displayName: 'Retail Trade', valueCaption: IndustryClassificationEnumV4.RetailTrade },
            ];

            const healthEducationAndCommunityServices: ListItem[] = [
                { value: IndustryClassificationEnumV4.EducationAndTraining, displayName: 'Education and Training', valueCaption: IndustryClassificationEnumV4.EducationAndTraining },
                { value: IndustryClassificationEnumV4.HealthCareAndSocialAssistance, displayName: 'Health Care and Social Assistance', valueCaption: IndustryClassificationEnumV4.HealthCareAndSocialAssistance },
                { value: IndustryClassificationEnumV4.PublicAdministrationAndSafety, displayName: 'Public Administration and Safety', valueCaption: IndustryClassificationEnumV4.PublicAdministrationAndSafety },
            ];

            const businessFinanceAndProfessionalServices: ListItem[] = [
                                { value: IndustryClassificationEnumV4.AdministrativeAndSupportServices, displayName: 'Administrative and Support Services', valueCaption: IndustryClassificationEnumV4.AdministrativeAndSupportServices },
                { value: IndustryClassificationEnumV4.FinancialAndInsuranceServices, displayName: 'Financial and Insurance Services', valueCaption: IndustryClassificationEnumV4.FinancialAndInsuranceServices },
                { value: IndustryClassificationEnumV4.ProfessionalScientificAndTechnicalServices, displayName: 'Professional, Scientific and Technical Services', valueCaption: IndustryClassificationEnumV4.ProfessionalScientificAndTechnicalServices },
            ];

            const informationMediaAndTelecommunications: ListItem[] = [
                                { value: IndustryClassificationEnumV4.InformationMediaAndTelecommunications, displayName: 'Information Media and Telecommunications', valueCaption: IndustryClassificationEnumV4.InformationMediaAndTelecommunications },
            ];

            const industrialAndUtilityServices: ListItem[] = [
                { value: IndustryClassificationEnumV4.ElectricityGasWaterAndWasteServices, displayName: 'Electricity, Gas, Water and Waste Services', valueCaption: IndustryClassificationEnumV4.ElectricityGasWaterAndWasteServices },
                { value: IndustryClassificationEnumV4.Manufacturing, displayName: 'Manufacturing', valueCaption: IndustryClassificationEnumV4.Manufacturing },
                { value: IndustryClassificationEnumV4.TransportPostalAndWarehousing, displayName: 'Transport, Postal and Warehousing', valueCaption: IndustryClassificationEnumV4.TransportPostalAndWarehousing },
                { value: IndustryClassificationEnumV4.WholesaleTrade, displayName: 'Wholesale Trade', valueCaption: IndustryClassificationEnumV4.WholesaleTrade },
            ];
            
            const groupedOptions: GroupedListItem[] = [
                {
                    label: 'Trades & Primary Industries',
                    options: tradesAndPrimaryIndustries
                },
                {
                    label: 'Consumer Services & Retail',
                    options: consumerServicesAndRetail
                },
                {
                    label: 'Health, Education & Community Services',
                    options: healthEducationAndCommunityServices
                },
                {
                    label: 'Business, Finance & Professional Services',
                    options: businessFinanceAndProfessionalServices
                },
                {
                    label: 'Leadership & Media',
                    options: informationMediaAndTelecommunications
                },
                {
                    label: 'Industrial & Utility Services',
                    options: industrialAndUtilityServices
                }
            ];

            this.groupedOptions = groupedOptions;
        }
    }
}
